import React from 'react';
import ReactDom from 'react-dom';

import CountdownTimer from '../Components/CountdownTimer/index.jsx';
import ErrorBoundary from '../Components/ErrorBoundary/index.jsx';


export default function(document) {
  var elements = document.querySelectorAll('[data-react-component="cs-countdown-timer"]');

  if (elements && elements.length) {
    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];

      var seconds = element.dataset.seconds;

      if (seconds) {
        seconds = parseInt(seconds);

        ReactDom.render(
          <ErrorBoundary>
            <CountdownTimer seconds={seconds} />
          </ErrorBoundary>,
          element
        );
      }
    }
  }
};

